import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { metersQueryKey } from '../queries/useMeters'
import type { Meter, MeterWrite } from '../types'

export function useCreateMeter() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function createMeter(body: MeterWrite) {
    const response = await apiClient.post<Meter>(SNA_PREFIX + 'meters', body)
    return response.data
  }

  return useMutation({
    mutationFn: createMeter,
    onSuccess: () => {
      toast.success({ message: t('meterCreated') })
      queryClient.invalidateQueries({ queryKey: metersQueryKey })
    },
    onError
  })
}
